import { SERVER_API } from 'SharedDir/constants/app/endpoints';

export const generalizedHistoryUrl = `${SERVER_API}/generalized-history`;
